import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import Pagination from '.'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/Pagination', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <div style={{ display: 'table', margin: '0 auto' }}>
        <Pagination
          criterion={{
            total: 100,
            _perpage: 8
          }}
          config={{
            previousPageLabel: 'Prev',
            nextPageLabel: 'Next',
            onCurrentIndexChanged: (idx) => {
              console.log('react navigating to page', idx + 1)
            }
          }}
        />
      </div>
    </ThemeProvider>
  ))
  .add('Starting Page', () => (
    <ThemeProvider theme={builtTheme}>
      <div style={{ display: 'table', margin: '0 auto' }}>
        <Pagination
          criterion={{
            total: 100,
            _perpage: 8,
            _page: 8
          }}
          config={{
            previousPageLabel: 'Prev',
            nextPageLabel: 'Next',
            onCurrentIndexChanged: 'callBackPageChange'
          }}
        />
      </div>
    </ThemeProvider>
  ))
